import axios from 'v1/utils/axios';

export default function notifications(container = $('body')) {
  const $counter = container.find('@notificationsCounter');
  const $remove = container.find('@removeNotification');
  const $removeAll = container.find('@delNotifications');
  const $allMessages = container.find('@message');

  function setCounter(count) {
    if (count > 0) {
      $counter.text(count);
    } else {
      $counter.text(0);
      $counter.remove();
      $('@openModal').removeClass('.notifications_informer__icon-active');
      $.modal.close();
    }
  }

  function removeAllMessages() {
    $allMessages.fadeOut(600, function() {
      $(this).remove();
    });
    $counter.remove();
    $('@openModal').removeClass('.notifications_informer__icon-active');
  }

  function responseRemove(url = '') {
    axios
      .post(url)
      .then((response) => {
        setCounter(response.data.notifications_count);
      })
      .catch((error) => console.log(error));
  }

  $.each($remove, function() {
    const $this = $(this);

    $this.on('click', (e) => {
      const $this = $(this);
      const $message = $this.parents('@message');
      const $url = $this.data('href');
      e.preventDefault();

      responseRemove($url);
      $message.fadeOut(600, () => {
        $this.remove();
      });
    });
  });

  $removeAll.on('click', function(e) {
    e.preventDefault();

    const $this = $(this);
    const $url = $this.attr('href');

    responseRemove($url);
    removeAllMessages();
  });
}
